import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { getStorage } from '../utils/functions/localstorage';
import { decodeJwt } from '../utils/functions/accessRight';

function ProtectedRoutes({ allowedRoles }) {
  const token = getStorage('token');

  if (!token) {
    return <Navigate to="/login" />;
  }
  const userRole = decodeJwt(token).ROLE || decodeJwt(token).role;
  // ลองเปิด Console log ดูว่าค่า userRole คืออะไร และ allowedRoles มีค่านั้นไหม
  console.log('User Role from Token:', userRole); 
  console.log('Allowed Roles:', allowedRoles);

  if (allowedRoles && !allowedRoles.includes(decodeJwt(token).ROLE || decodeJwt(token).role)) {
    return <Navigate to="/404" />;
  }

  return <Outlet />;
}


export default ProtectedRoutes;
